import React, { useContext, useEffect, useState } from 'react'
import "./style.scss"
import Input from '../../../Input';
import { toAbsoluteUrl } from '../../../../utils/assetHelper';
import { AuthContext } from '../../../../context/auth';
import PhotoShapemodal from './photoShapeModal';
import DeleteModal from '../../DeleteModal';
import { updateTeamMember, addTeamMember, addTeamRole } from '../../../../api';

const Index = ({ setOpenAddMemberModal, openAddMemberModal, role, selectedMember, reset, setTeamsData, teamsData, fetchTeamsRole }) => {
  const { setNotification, setIsLoading } = useContext(AuthContext)
  const [photoShapeModal, setPhotoShapeModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [selectedPhoto, setSelectedPhoto] = useState('');
  const [selectedPhotoShape, setSelectedPhotoShape] = useState('');
  const [name, setName] = useState('')
  const [position, setPosition] = useState('')
  const [position2, setPosition2] = useState('')
  const [description, setDesciption] = useState('')


  const onUpload = (e) => {
    const file = e.target.files[0]
    if (file) {
      // const reader = new FileReader()
      // reader.onload = (e) => {
      //   document.querySelector(".avatar-uploader img").setAttribute("src", e.target.result)
      // }
      // reader.readAsDataURL(file)
      setPhotoShapeModal(true)
      setSelectedPhoto(file)
      // setSelectedPhoto(URL.createObjectURL(file))
    }

  }


  useEffect(() => {
    if (selectedMember) {
      setSelectedPhoto(selectedMember.image)
      setSelectedPhotoShape(selectedMember.image_layout)
      setName(selectedMember.name)
      setPosition(selectedMember.position_1)
      setPosition2(selectedMember.position_2)
      setDesciption(selectedMember.bio)
    }
  }, [selectedMember])



  if (photoShapeModal) {
    return <PhotoShapemodal setPhotoShapeModal={setPhotoShapeModal} setSelectedPhotoShape={setSelectedPhotoShape} selectedPhoto={selectedPhoto} setSelectedPhoto={setSelectedPhoto} />
  }

  if (deleteModal) {
    return <DeleteModal setDeleteModal={setDeleteModal} setOpenAddMemberModal={setOpenAddMemberModal} reset={reset} fetchTeamsRole={fetchTeamsRole} selectedMember={selectedMember} />
  }


  return (
    <div className="small-modal-wrapper">
      <div className="small-modal-content">
        <span className='close' onClick={() => {
          setOpenAddMemberModal(false)
          reset()
        }}><i className="fas fa-times"></i></span>
        {selectedMember && <span className='delete' onClick={() => setDeleteModal(true)}>
          <i className="fal fa-trash-alt"></i></span>}
        <h2>{selectedMember ? 'Edit Member' : 'Add New Member'}</h2>
        <div className="form-container">
          <div className="img-container">
            <div className="avatar-uploader">
              <input type="file" className='image-file' accept="image/*" onChange={onUpload} />
              <img src={selectedPhoto ? selectedPhoto : toAbsoluteUrl("/media/avatar.png")} alt="" />
              <span>Change</span>
            </div>
          </div>
          <div className="input-container">
            <label htmlFor="name">Name <span>*</span></label>
            <Input type='text' placeholder='Name' value={name} onChange={e => setName(e.target.value)} />
          </div>
          <div style={{ display: 'flex', gap: '24px' }}>
            <div className="input-container">
              <label htmlFor="position">Position 1 <span>*</span></label>
              <Input type='text' placeholder='Position 1' value={position} onChange={e => setPosition(e.target.value)} />
            </div>
            <div className="input-container">
              <label htmlFor="position2">Position 2 </label>
              <Input type='text' placeholder='Position 2' value={position2} onChange={e => setPosition2(e.target.value)} />
            </div>
          </div>
          <div className="input-container">
            <div className="two-column" style={{ display: 'flex', justifyContent: 'space-between' }}>
              <label htmlFor="position2">Bio <span>*</span></label>
              <label>2800 character limit</label>
            </div>
            <textarea cols={30} rows={10}
              style={{ resize: "none", borderRadius: "8px" }}
              placeholder='Type Here...'
              value={description}
              onChange={e => setDesciption(e.target.value.slice(0, 2800))}

            ></textarea>
          </div>
        </div>
        <button className='btn add-btn'
          disabled={!name || !position || !description}
          onClick={() => {
            setIsLoading(true)
            if (selectedMember) {
              updateTeamMember(selectedMember.id, {
               name: name,
               position_1: position,
               position_2: position2,
               bio: description,
               image: selectedPhoto, 
               image_layout: selectedPhotoShape ? selectedPhotoShape : null
              }).then(() => {
                setOpenAddMemberModal(false)
                reset()
                fetchTeamsRole()
                setIsLoading(false)
                  setNotification({
                message: "Changes Successfully Saved!",
                type: "edit"
              })
              }).catch(() => {
                setIsLoading(false)
                setNotification({
                  message: "Something went wrong",
                  type: "error"
                })
              })
            
            } else {
              // setNotification({
              //   message: "New Member Successfully Added",
              //   type: "add"
              // })
              // const newMember = {
              //   id: Math.floor(Math.random() * 100),
              //   name: name,
              //   position: position,
              //   position2: position2,
              //   img: selectedPhoto,
              //   shapeType: selectedPhotoShape,
              // }

              // setTeamsData(teamsData.map((item) => {
              //   if (item.type === role) {
              //     return {
              //       ...item,
              //       teams: [...item.teams, newMember]
              //     }
              //   }
              //   return item
              // }))
              if (teamsData.find((item) => item.name === role)) {
                // add team member to that role
                let roleId = teamsData.find((item) => item.name === role).id;
                let teamLength = teamsData.find((item) => item.name === role).teams.length + 1
                const data = {
                  name: name,
                  position_1: position,
                  position_2: position2,
                  bio: description,
                  image: selectedPhoto,
                  image_layout: selectedPhotoShape ? selectedPhotoShape : null,
                  role: roleId,
                  order: teamLength
                }
                addTeamMember(data).then((res) => {
                  if (res && res.data) {
                    setNotification({
                      message: "New Member Successfully Added",
                      type: "add"
                    })
                    fetchTeamsRole()
                    setOpenAddMemberModal(false)
                    reset()
                    setIsLoading(false)
                  } else {
                    setNotification({
                      message: "Something went wrong",
                      type: "red"
                    })
                  }
                }).catch((err) => {
                  setNotification({
                    message: "Something went wrong",
                    type: "red"
                  })
                  setIsLoading(false)
                })

              } else {
                // create role and then add team member to that role by using its role id
                addTeamRole({ name: role }).then((res) => {
                  if (res && res.data) {
                    let roleId = res.data.team?.id
                    const data = {
                      name: name,
                      position_1: position,
                      position_2: position2,
                      bio: description,
                      image: selectedPhoto,
                      image_layout: selectedPhotoShape ? selectedPhotoShape : null,
                      role: roleId,
                      order: 0
                    }
                    addTeamMember(data).then((res) => {
                      if (res && res.data) {
                        setNotification({
                          message: "New Member Successfully Added",
                          type: "add"
                        })
                        fetchTeamsRole()
                        setOpenAddMemberModal(false)
                        reset()
                        setIsLoading(false)
                      }
                    })
                  } else {
                    setNotification({
                      message: "Something went wrong",
                      type: "red"
                    })
                    setIsLoading(false)
                  }
                }).catch((err) => {
                  setNotification({
                    message: "Something went wrong",
                    type: "red"
                  })
                  setIsLoading(false)
                })
              }
            }
          }}>{selectedMember ? 'Save Changes' : 'Add New Member'}</button>
        <button className='btn transparent' onClick={() => {
          setOpenAddMemberModal(false)
          reset()
        }}>Cancel</button>
      </div>
    </div>
  )
}

export default Index